const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/roadmaps/$roadmapId/view/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { redirectToFirstView } from 'src/lib/utils/roadmapping/redirectToFirstView';
export const Route = createFileRoute('/(app)/org/$org/roadmaps/$roadmapId/view/')({
  loader: async ({
    params: {
      org,
      roadmapId
    },
    context: {
      queryClient
    }
  }) => {
    await redirectToFirstView({
      org,
      roadmapId: Number(roadmapId),
      queryClient
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});